import { appSuccessToast } from "../components/common";
import axiosInstance from "../utils/axios";
import {
    INotificationSettings,
    IUpdateSettingsRequest,
    IWorkingHourSetting
} from "./types/settings";

const pathPrefix = `${process.env.REACT_APP_SERVER_URL}/api`;

class SettingsService {
    async getNotificationSettings(): Promise<INotificationSettings> {
        const response = await axiosInstance
            .get<INotificationSettings>(`${pathPrefix}/settings/notification-settings`);
        return await Promise.resolve(response.data);
    }

    async updateSettings(settings: IUpdateSettingsRequest): Promise<void> {
        await axiosInstance
            .put(`${pathPrefix}/settings/update`, {
                NotifyWorktimeStart: settings.notifyWorktimeStart,
                NotifyWorktimeEnd: settings.notifyWorktimeEnd,
                NotifyWorktimeModification: settings.notifyWorktimeModification,
                NotifyNewAssignnment: settings.notifyNewAssignnment,
                NotifyAssignmentCanceled: settings.notifyAssignmentCanceled,
                NotifyAssignmentRejected: settings.notifyAssignmentRejected,
                NotifyAssignmentRealized: settings.notifyAssignmentRealized,
                NotifyAssignmentNotRealized: settings.notifyAssignmentNotRealized,
                NotifyAssignmentAcceptedOvertime: settings.notifyAssignmentAcceptedOvertime,
                NotifyApplicationCanceled: settings.notifyApplicationCanceled,
                NotifyApplicationAcceptedOvertime: settings.notifyApplicationAcceptedOvertime,
                NotifyApplicationAcceptedLeaving: settings.notifyApplicationAcceptedLeaving,
                NotifyApplicationRejected: settings.notifyApplicationRejected,
                NotifyNewApplication: settings.notifyNewApplication,
                NotifyCollectedTime: settings.notifyCollectedTime,
                NotifyDeletedTimeCollection: settings.notifyDeletedTimeCollection,
                NotifyNewUser: settings.notifyNewUser,
            });
        appSuccessToast("Ustawienia zostały zaktualizowane");
        return await Promise.resolve();
    }

    async getWorkingHoursSettings(year: number): Promise<IWorkingHourSetting[]> {
        const response = await axiosInstance
            .get<IWorkingHourSetting[]>(`${pathPrefix}/settings/working-hours/${year}`);
        return await Promise.resolve(response.data);
    }

    async saveWorkingHoursSettings(year: number, data: IWorkingHourSetting[]): Promise<void> {
        await axiosInstance
            .put(`${pathPrefix}/settings/working-hours/${year}`, data)
            .then((response) => {
                appSuccessToast("Godziny robocze zostały zaktualizowane");
                return response;
            });
    }
}

const settingsService = new SettingsService();
export default settingsService;